import * as ActionCable from '@rails/actioncable'
import config from './config'

const cable = ActionCable.createConsumer(config.CABLE_URL)

export default cable
